import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import { DateRangeInput } from '../DateRange'
import { DispositionExplainer } from '../DispositionExplainer'

/**
 * DateRangeController component handles the date range selection UI and disposition explanation
 */
export const FilterDateRangeControllerView = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  dispositionExpanded,
  onDispositionToggle,
  disabled = false
}) => {
  return (
    <Box>
      {/* Call Classification Definitions Reference - Expandable */}
      <DispositionExplainer
        initiallyExpanded={dispositionExpanded}
        onToggle={onDispositionToggle}
        disabled={disabled}
      />

      <DateRangeInput
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        disabled={disabled}
      />
    </Box>
  )
}

FilterDateRangeControllerView.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  dispositionExpanded: PropTypes.bool,
  onDispositionToggle: PropTypes.func,
  disabled: PropTypes.bool
}

export const DateRangeController = FilterDateRangeControllerView

export default DateRangeController
